<template>
  <div class="wrapper">
    <div class="header">
      <div class="aa"></div>
      <div class="title">{{ $t('personCenterV2.personCenter') }}</div>
    </div>

    <!-- 个人中心 -->
    <div class="userInfo">
      <div class="left_img">
        <div class="logo_img">
          <img :src="imgUrl" class="pic" />
        </div>
      </div>
      <div class="right_text">
        <div class="text">
          <span class="name">{{ userInfo.nickName }}</span>
          <div class="bg_box">
            <span class="major">{{ getUserInfoForVueX.roleName }}</span>
            <!-- <span class="major"
                  v-if="userInfo.identityType === 0">{{ $t('personCenterV2.ordinary') }}</span>
            <span class="major"
                  v-if="userInfo.identityType === 1">{{ $t('personCenterV2.teacher') }}</span>
            <span class="major"
                  v-if="userInfo.identityType === 2">{{ $t('personCenterV2.student') }}</span>
            <span class="major"
                  v-if="userInfo.identityType === 3">{{ $t('personCenterV2.leader') }}</span> -->
          </div>
        </div>

        <div class="prop">
          <span class="email" v-if="userInfo.email">{{ $t('personCenterV2.email') }}:
            {{ userInfo.email }}</span>
          <div class="hobby" v-if="newPeon.length">
            <div class="lang">{{ $t('personCenterV2.language') }}:</div>
            <div class="language" v-for="(item, index) in newPeon" :key="item.id">
              <span>{{ $i18n.locale === 'zh' ? item.langName : $langCase[item.langCode] }}</span>
              <span v-if="index != newPeon.length - 1">,</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="btn">
      <button @click="editInfo">{{ $t('personCenterV2.editInfo') }}</button>
      <button @click="editPassword" class="primary">{{ $t('personCenterV2.editPass') }}</button>
    </div>

    <!-- 我的团队 -->
    <div class="my-team">
      <div class="header">
        <div class="aa"></div>
        <div class="title">{{ $t('personCenterV2.myTeam') }}</div>
      </div>
      <div class="team_box" v-for="item in MyTeamInfo" :key="item.id">
        <div class="team_left">
          <span class="team_name">{{ item.teamName }}</span>
          <p class="number">{{ item.teamNumber }}{{ $t('personCenterV2.person') }}</p>
          <div class="team_btn">
            <div class="team_text" @click="checkTeamInfo(item.companyCode)">
              {{ $t('personCenterV2.check') }}</div>
          </div>
        </div>
        <div class="team_logo" @click="editTeamInfo()"></div>
      </div>
    </div>

    <!--我加入的团队 -->
    <div class="join_team">
      <div class="header">
        <div class="aa"></div>
        <div class="title">{{ $t('personCenterV2.myJoinTeam') }}</div>
      </div>
      <div class="flex">
        <div class="join_box" v-for="(item, index) in MyJoinTeamInfo" :key="index">
          <div class="join_name">
            <span class="join_info">{{ item.teamName }}</span>
          </div>
          <div class="join_number">{{ item.teamNumber }}{{ $t('personCenterV2.person') }}</div>
          <div class="join_btn">
            <div class="join_info" @click="logoutTeam(item.companyCode, item.companyId)">
              <span class="info">{{ $t('personCenterV2.logOut') }}</span>
            </div>
            <div class="join_look" @click="checkJoinTeam(item.companyCode, item.teamName)">
              <span class="look">{{ $t('personCenterV2.check') }}</span>
            </div>
          </div>
        </div>
        <div class="join_box join_empty" v-if="MyJoinTeamInfo.length === 0">
          <span>{{ $t('personCenterV2.notJoinTeam') }}</span></div>
      </div>
    </div>

    <!-- 修改个人信息弹窗组件       -->
    <editUserInfo :dialogVisible="userInfoDiaolog" @closeUserInfo="closeUserInfoDialog"
                  :userInfo="userInfo" :langList="langList" @func="getLangList" @update="isUpdate"
                  ref="editInfos"> </editUserInfo>

    <!-- 修改密码弹窗弹窗组件 -->
    <editPassword :dialogVisible="isShowDialog" @closeEditPassword="closeDialog"
                  :oldPassInfo="oldPassInfo" />

    <!-- 修改团队信息弹窗组件 -->
    <editTeam :dialogVisible="userTeamDiaolog" :MyTeamInfo="MyTeamInfo" @closeTeam="closeTeamDialog"
              ref="editRef"> </editTeam>

    <!-- 删除团队弹窗组件 :MyJoinTeamInfo="MyJoinTeamInfo" -->
    <deleteDialog :dialogVisible="deleteDialog" @closeDeleteDialog="closeDelete"
                  :companyCode="companyCode" :companyId="companyId"></deleteDialog>

    <!-- 查看我的团队信息弹窗 -->
    <div class="checkBox">
      <el-dialog class="box" :visible.sync="TeamDialogVisible" :close-on-click-modal="false">
        <div slot="title" class="el-dialog__title">
          <div class="title-left"></div>
          <slot name="title">{{joinName}}</slot>
          <div class="title-right"></div>
        </div>
        <el-table border height="300px" v-loading="loding" :data="tableData" ref="multipleTable"
                  header-row-class-name="customHeader">
          <el-table-column type="index" :label="$t('personCenterV2.index')" width="60"
                           align="center"> </el-table-column>

          <el-table-column prop="aliasName" :label="$t('personCenterV2.name')" align="center">
            <template slot-scope="{row}">{{row.aliasName || '--'}}</template>
          </el-table-column>

          <!-- 独立部署显示为邮箱，飞译都显示 -->
          <el-table-column prop="loginPhone" :label="$t('managementV2.phone')" align="center"
                           show-overflow-tooltip v-if="!(IS_PRIVATE || IS_ONLINE_PRIVATE)">
            <template slot-scope="{row}">{{row.loginPhone || '--'}}</template>
          </el-table-column>
          <el-table-column prop="email" :label="$t('personCenterV2.email')" align="center">
            <template slot-scope="{ row }">{{row.email || '--'}}</template>
          </el-table-column>

          <el-table-column prop="roleName" :label="$t('personCenterV2.role')" align="center">
            <template slot-scope="scoped">
              {{ $i18n.locale === 'zh' ? scoped.row.roleName : $roleCase[scoped.row.roleType] }}
            </template>
          </el-table-column>
        </el-table>
        <div class="pagination">
          <el-pagination background @current-change="handleCurrentChange"
                         @size-change="handleSizeChange" :page-size="queryTabel.rows"
                         :current-page="queryTabel.page" :page-sizes="[10, 20, 30, 40]"
                         layout="prev, pager, next, sizes" :total="tableDataInfo.totalRows">
          </el-pagination>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="handleClose">{{ $t('personCenterV2.confirm') }}
          </el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { checkImgExists } from "@/utils/index";

// 引入对话框组件
import editPassword from '../../components/layer/createPersonDialog/editPassword'
import editUserInfo from '../../components/layer/createPersonDialog/editUserInfo'
import editTeam from '../../components/layer/createPersonDialog/editTeam'
import deleteDialog from '../../components/layer/createPersonDialog/deleteDialog'

// 引入接口
import { olduserInfo, teamInfo, MyJoinTeamInfo, checkTeamNum } from '../../services/userInfo'
import { mapState } from 'vuex';

export default {
  name: 'personCenter',
  components: {
    editPassword,
    editUserInfo,
    editTeam,
    deleteDialog,
  },
  data() {
    return {
      IS_PRIVATE: IS_PRIVATE,
      IS_ONLINE_PRIVATE: IS_ONLINE_PRIVATE,
      // 对话框的显示与隐藏
      isShowDialog: false,
      userInfoDiaolog: false,
      userTeamDiaolog: false,
      deleteDialog: false,
      // 存储个人中心数据
      userInfo: {},
      //  我的团队信息
      MyTeamInfo: [],
      //  我加入的团队信息
      MyJoinTeamInfo: [],
      //  查看我的团队信息
      tableData: [],
      // 团队信息弹窗
      TeamDialogVisible: false,
      // 查看分页接口中的姓名
      joinName: '',
      //  传递全部语言列表
      langList: [],
      //  存储修改密码信息
      oldPassInfo: {},
      arr: [],
      // 接受用户管理选中的语言,去重后的数组
      newPeon: [],
      //请求表格数据源
      queryTabel: {
        filter: {
          companyCode: '',
        },
        page: 1,
        rows: 10,
        sort: { createTime: 'desc' },
      },
      // 表格全部数据
      tableDataInfo: {
        totalRows: 0,
        totalPage: 0,
      },
      avatar: '', //接口头像地址
      imgUrl: require('./assets/images/user.png'), //本地头像地址
      companyCode: 0, //退出团队code
      companyId: 0, //退出团队id
      selfCompany: '', //自己团队的code
      loding:false
    };
  },
  computed: {
    ...mapState("layout",['navInfo']),
    //获取用户信息
    getUserInfoForVueX () {
      return this.$store.getters['layout/getUserInfo']
    }
  },
  watch: {
    'userInfo.avatar': {
      handler(newVal) {
        checkImgExists(newVal).then(() => {
          this.imgUrl = newVal;
        }).catch(() => {
          this.imgUrl = require('./assets/images/user.png');
        });
      },
      deep: true,
    },
  },

  methods: {
    //  修改用户信息对话框
    editInfo() {
      this.userInfoDiaolog = true
      this.getolduserInfo()
      this.$refs.editInfos.languageInfo()
    },
    // 关闭对话框
    closeUserInfoDialog() {
      this.userInfoDiaolog = false
    },
    // 修改密码对话框
    editPassword() {
      this.isShowDialog = true
    },
    closeDialog() {
      this.isShowDialog = false
    },
    // 修改团队信息对话框
    editTeamInfo() {
      this.userTeamDiaolog = true
    },
    closeTeamDialog() {
      this.userTeamDiaolog = false
      this.getTeamInfo() //同步刷新界面
    },

    //   旧用户信息接口
    async getolduserInfo() {
      const res = await olduserInfo()
      if (!res || !res.result) return
      this.userInfo = res.result
      console.log(this.userInfo);
      this.langList = Array.isArray(res.result.userLangList) ? res.result.userLangList : []
      this.oldPassInfo = res.result
      //  对新数组进行去重
      let newObj = {}
      this.newPeon = this.langList.reduce((cur, next) => {
        newObj[next.langCode] ? '' : (newObj[next.langCode] = true && cur.push(next))
        return cur
      }, []) //设置cur默认类型为数组，并且初始值为空的数组
    },

    // 获取新用户信息
    async getUserInfo() {
      // const { result } = await userInfo()
      // if (result.avatar === '') {
      //   this.avatar = this.defaultImgUrl
      // } else {
      //   this.avatar = result.avatar
      // }
    },

    // 获取我的团队信息接口数据
    async getTeamInfo() {
      const response = await teamInfo()
      const result = response && response.result
      if (!result) {
        this.MyTeamInfo = []
        return
      }
      this.MyTeamInfo = result
      this.selfCompany = result.companyCode
    },

    // 获取我加入的团队数据
    async getMyJoinTeamInfo() {
      const response = await MyJoinTeamInfo()
      const result = response && response.result
      this.MyJoinTeamInfo = Array.isArray(result) ? result : []
    },

    // 退出我加入的团队
    logoutTeam(code, id) {
      this.deleteDialog = true
      this.companyCode = code
      this.companyId = id
    },
    closeDelete() {
      this.deleteDialog = false
    },
    // 获取子组件传递过来的语言列表
    getLangList(data) {
      data.forEach((item) => {
        let Obj = {}
        Obj.code = item.langCode
        Obj.name = item.langName
        this.arr.push(Obj)
      })
    },

    // 查看我的团队的信息，跳转到团队成员模块
    async checkTeamInfo(query) {
      const self = this;
      const url = this.navInfo.find(item=>item.code == "team_manage").url
      console.log(url,this.navInfo);
      if (localStorage.companyCode != query) {
        let params = Object();
        Reflect.set(params, 'companyCode', query);
        self.$store.dispatch('layout/changeCompanyInfo', params).then(async (resp) => {
          if (resp.status === 200 && resp.success) {
            let result = resp.result;
            localStorage.setItem('myUser', JSON.stringify(result));
            localStorage.setItem('userInfo', JSON.stringify(result));
            localStorage.setItem('companyCode', query); // 公司编码
            localStorage.setItem('myCompanyCode', query); // 公司编码
            await self.$store.dispatch('layout/navInfo', query);
            self.$router.push({ path: url });
            setTimeout(() => {
              location.reload();
            }, 50);
          }
        })
      } else {
        self.$router.push({ path: url });
      }

      // 老代码 LSYu改
      // localStorage.setItem('companyCode', query)
      // this.$store.commit('setCompanyCode', query)
      // const res = await changeTeam({ companyCode: query })
      // this.$router.push({ name: 'manage' })
      // window.setTimeout(() => {
      //   location.reload()
      // }, 50)
    },

    // 查看我加入的团队信息,接收上面传递的code和name
    async checkJoinTeam(val, name) {
      this.TeamDialogVisible = true
      this.joinName = name
      let code = val + ''
      this.queryTabel.filter.companyCode = code
      const result = await checkTeamNum(this.queryTabel)
      // 只获取status为1的数据
      let status1 = 1
      let newList = result.list.filter((item) => {
        return item.status === status1
      })
      this.tableData = newList
      this.tableDataInfo.totalPage = result.totalPage
      this.tableDataInfo.totalRows = result.totalRows
    },
    // 获取全部团队管理分页列表数据
     queryJobData() {
      setTimeout( async() => {
        const { list } = await checkTeamNum(this.queryTabel)
        this.tableData = list
        this.loding=false
      }, 0);
    },
    // 当前页码数
    handleCurrentChange(currentPage) {
      this.loding=true
      this.queryTabel.page = currentPage
      this.queryJobData()
      sessionStorage.setItem('change', 1) //保存第一页数据
    },
    // 每页显示多少条数据
    handleSizeChange(pageSize) {
      this.loding=true
      this.queryTabel.rows = pageSize
      this.tableData = undefined
      this.handleCurrentChange(1)
    },
    // 关闭对话框,重置table数据
    handleClose() {
      this.TeamDialogVisible = false
      this.queryTabel.page = 1 //关闭时，将第一页的值赋给当前页
      this.queryTabel.rows = 10;
      this.queryJobData()
    },
    // 确认之后，更新头部name和团队name
    editUserInfo() {
      let self = this
      self.$store.dispatch('layout/userInfo').then((resp) => {
        if (!!resp && resp.status === 200 && resp.success) {
          let result = resp.result
          let companyCode = result.lastSelectCompany.code
          localStorage.setItem('myUser', JSON.stringify(result))
          localStorage.setItem('userInfo', JSON.stringify(result))
          localStorage.setItem("sourceAppid", result.sourceAppid);
          localStorage.setItem('companyCode', result.lastSelectCompany.code) // 公司编码
          localStorage.setItem('myCompanyCode', result.lastSelectCompany.code) // 公司编码
        }
      })
    },
    // 更新的事件
    isUpdate() {
      this.editUserInfo()
      this.getolduserInfo()
      this.getUserInfo()
    },
  },
  created() {
    // 进入页面拿到当前数据赋值给当前页
    this.queryTabel.page = Number(sessionStorage.getItem('change'))
  },
  //   初始化获取个人信息和团队数据
  mounted() {
    this.getolduserInfo()
    this.getUserInfo()
    this.getTeamInfo()
    this.getMyJoinTeamInfo()
    this.bus.$on('updateMyJoinedTeam', () => {
      this.getMyJoinTeamInfo();
    });
  },
  destroyed() {
    this.bus.$off('updateMyJoinedTeam');
  }
}
</script>

<style lang="less" scoped>
@import "./assets/style.less";
</style>
